module.exports = __webpack_public_path__ + "static/media/img-holder.5227ffa8.svg";